import React, {FC} from 'react';

import {colorForInteger} from '../../../../libs/shared/core/src/models/helpers/colorHelpers';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {makeSizeConstants} from '../../../../libs/shared/ui/src/styles/styleHelpers';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {getApplications} from '../../../store/data/applications/applicationsSelectors';
import {ApplicationCardImageAvatar} from './applicationCardImageAvatar';
import {ApplicationCardInitialsAvatar} from './applicationCardInitialsAvatar';

/*
 * Constants.
 */

const imgSizes = makeSizeConstants(12, 16, 24, 30);

/*
 * Props.
 */

interface ApplicationIconProps {
  applicationId: number;
  size?: VisualSizesEnum;
}

export const ApplicationIcon: FC<ApplicationIconProps> = (props) => {
  const theme = useUserTheme();
  const {size = VisualSizesEnum.MEDIUM} = props;

  const application = useAppSelector((state) => {
    const applications = getApplications(state);
    return applications[props.applicationId];
  });

  if (!application) {
    return <Icon name="integrationsFilled" color={theme.greys.shade60} size={imgSizes[size]} />;
  }

  if (application.iconUrl) {
    return <ApplicationCardImageAvatar url={application.iconUrl} size={size} />;
  }

  return (
    <ApplicationCardInitialsAvatar
      name={application.name}
      color={colorForInteger(application.id)}
      size={size}
    />
  );
};
